import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  root: {
    width: '82%',
    padding: '3% 3%',
    margin: 'auto',
  },
  title: {
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '18px',
    lineHeight: '22px',
    alignItems: 'center',
    marginTop: '34px',
    color: '#DF0C36',
    marginBottom: 7,
  },
  contentPaper: {
    width: '100%',
    margin: '0px !important',
    borderTop: '2px solid #DF0C36',
  },
  description: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '18px 48px',
    position: 'static',
    width: '80%',
    background: '#FAFAFA',
    borderRadius: '2px',
    flex: 'none',
    order: 0,
    flexGrow: 1,
    margin: '30px 0px 0px 60px',
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '14px',
    lineHeight: '20px',
    color: '#666666',
  },
  iframe: {
    margin: '30px 60px 30px 60px',
  },
  uploadButton: {
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '14px',
    backgroundColor: '#DF0C36',
    color: 'white',
    lineHeight: '20px',
    top: 0,
    zIndex: 1,
    position: 'fixed',
    right: 0,
    marginTop: '15%',
    marginRight: '4%',
    height: 40,
    width: 40,
    '&:hover': {
      backgroundColor: '#DF0C36',
      boxShadow: '5px 5px 5px lightGray, 0 0 25px lightGray, 0 0 25px white',
    },
  },
  downloadButton: {
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '14px',
    backgroundColor: 'white',
    color: '#DF0C36',
    lineHeight: '20px',
    top: 0,
    zIndex: 1,
    position: 'fixed',
    right: 0,
    marginTop: '20%',
    marginRight: '4%',
    height: 40,
    width: 40,
    '&:hover': {
      backgroundColor: 'white',
      boxShadow: '5px 5px 5px lightGray, 0 0 25px lightGray, 0 0 25px white',
    },
  },
  paper: {
    //  width: '700px',
  },
  popupTitle: {
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '28px',
    lineHeight: '36px',
    letterSpacing: 0,
    color: '#666666',
  },
  publishIcon: {
    color: '#DF0C36',
    margin: '30px 30px',
  },
  dialogTitle: {
    marginLeft: '15px',
    marginTop: '10px',
  },
  dialogContent: {
    marginLeft: '15px',
    marginRight: '80px',
  },
  dialogActions: {
    marginRight: '80px',
    marginBottom: '20px',
  },
  dialogText: {
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '14px',
    lineHeight: '20px',
    color: '#333333',
    textAlign: 'justify',
  },
  validateButton: {
    width: 110,
    height: 34,
    textTransform: 'none',
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '18px',
    lineHeight: '18px',
    backgroundColor: '#DF0C36',
    color: '#ffffff',
    borderRadius: 0,
    '&:hover': {
      backgroundColor: '#B00429',
    },
  },
  cancelButton: {
    width: 110,
    height: 34,
    textTransform: 'none',
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '18px',
    lineHeight: '18px',
    color: '#DF0C36',
    borderColor: '#DF0C36',
    borderRadius: 0,
    marginRight: '24px',
    '&:hover': {
      color: '#B00429',
      borderColor: '#B00429',
      backgroundColor: '#FFFFFF',
    },
  },
  loader: {
    color: '#DF0C36',
    position: 'fixed',
    left: '50%',
    top: '50%',
  },
  fileUploaderContent: {
    height: 305,
  },
  list: {
    listStyle: 'none',
    padding: 0,
    margin: '4px 0',
  },
  result: {
    borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
  },
  filename: {
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: 12,
    marginLeft: 20,
    color: '#666666',
  },
  error: {
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: 12,
    marginLeft: 20,
    color: '#FF7373',
    margin: 'auto',
  },
  errorGrid: {
    margin: '16px 0',
  },
  succedeedResult: {
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: 12,
    marginLeft: 20,
    color: '#17BF5E',
    margin: 'auto',
  },
  flexDiv: { display: 'flex', marginTop: 8 },
  errorIcon: { marginLeft: 8, color: '#FF7373' },
  successIcon: { marginLeft: 8, color: '#17BF5E' },
  forcastButton: {
    minWidth: 200,
    height: 34,
    textTransform: 'none',
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '18px',
    lineHeight: '18px',
    backgroundColor: '#DF0C36',
    color: '#ffffff',
    borderRadius: 0,
    '&:hover': {
      backgroundColor: '#B00429',
    },
  },
  uploadStatusLabel: {
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '20px',
    lineHeight: '28px',
    color: '#333333',
    marginTop: 32,
  },
  fileNotFoundIcon: { marginLeft: 8, color: '#41AFFF' },
  fileNotFound: {
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: 12,
    marginLeft: 20,
    color: '#41AFFF',
    margin: 'auto',
  },
  alert: {
    backgroundColor: '#2ECC71',
  },
  snackbar: {
    top: 100,
  },
}));
